module.exports = __webpack_public_path__ + "media/landing-page/hive-right-681eeb09.png";